import { connect } from 'react-redux';

import { search } from '../actions/users';
import { createPaycheck } from '../actions/paychecks';
import { showSnackbar } from '../actions/snackbar';
import ManualTab from '../components/Paychecks/ManualTab';

function mapStateToProps({ users, paychecks }) {
  return {
    users: users.users,
    ...paychecks,
  };
}

export default connect(mapStateToProps, { createPaycheck, search, showSnackbar })(ManualTab);



// WEBPACK FOOTER //
// ./src/containers/ManualTabContainer.js